import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { Button, Card, Badge } from "reactstrap";

//Simple bar
import SimpleBar from "simplebar-react";

//components
import AttachedFiles from "./AttachedFiles";
import CustomCollapse from "./CustomCollapse";

//actions
import { closeUserSidebar } from "../../store/messenger/layout/actions";
import { updateGroupConversation } from '../../services/conversations';

//i18n
import { useTranslation } from 'react-i18next';

//image
import avatar7 from "../../assets/images/users/avatar-7.jpg";


function UserProfileSidebar(props) {

  const [isOpen1, setIsOpen1] = useState(true);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [files] = useState([
    { name: "Admin-A.zip", size: "12.5 MB", thumbnail: "ri-file-text-fill" },
    { name: "Image-1.jpg", size: "4.2 MB", thumbnail: "ri-image-fill" },
    { name: "Image-2.jpg", size: "3.1 MB", thumbnail: "ri-image-fill" },
    { name: "Landing-A.zip", size: "6.7 MB", thumbnail: "ri-file-text-fill" },
  ]);

  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState("");

  const handleBlur = async () => {
    setIsEditing(false);
    if (name !== props.activeUser.name) {
      try {
        await updateGroupConversation(props?.activeUser?._id, { name });
        props.updateActiveUserName(name);
      } catch (error) {
        console.error("Error updating group name:", error);
      }
    }
  };

  /* intilize t variable for multi language implementation */
  const { t } = useTranslation();

  const toggleCollapse1 = () => {
    setIsOpen1(!isOpen1);
    setIsOpen2(false);
    setIsOpen3(false);
  };

  const toggleCollapse2 = () => {
    setIsOpen2(!isOpen2);
    setIsOpen1(false);
    setIsOpen3(false);
  };

  const toggleCollapse3 = () => {
    setIsOpen3(!isOpen3);
    setIsOpen1(false);
    setIsOpen2(false);
  };

  useEffect(() => {
    setName(props.activeUser?.name || "");
  }, [props.activeUser]);

  // closes sidebar
  const closeuserSidebar = () => {
    props.closeUserSidebar();
  }

  const groupMemberDeleteHandler = async (memberId) => {
    const members = props.activeUser?.members?.map(member => String(member._id));
    const updatedMembers = members.filter(member => member !== memberId);

    const updatedGroup = {
      ...props.activeUser,
      members: updatedMembers
    };

    const res = await updateGroupConversation(props.activeUser?._id, updatedGroup);
    if (res.status === 200) {
      console.log("Group updated successfully");
      props.handleRemoveMember(memberId);
    } else {
      console.log("Error updating group");
    }
  }

  console.log("userSidebar", props);

  // style={{display: props.userSidebar  ? "block" : "none"}}
  return (
    <div style={{ display: (props.userSidebar === true) ? "block" : "none" }} className="user-profile-sidebar">
      <div className="px-3 px-lg-4 pt-3 pt-lg-4">
        <div className="user-chat-nav  text-end">
          <Button color="none" type="button" onClick={closeuserSidebar} className="nav-btn" id="user-profile-hide">
            <i className="ri-close-line"></i>
          </Button>
        </div>
      </div>

      <div className="text-center p-4 border-bottom">

        <div className="mb-4 d-flex justify-content-center">
          {
            props?.activeUser?.user?.imageSrc === "Null" ?
              <div className="avatar-lg">
                <span className="avatar-title rounded-circle bg-soft-primary text-primary font-size-24">
                  {props?.activeUser?.name?.charAt(0)}
                </span>
              </div>
              : <img src={props?.activeUser?.isGroupChat ? "https://static.vecteezy.com/system/resources/thumbnails/021/063/599/small/group-coaching-icon-vector.jpg" : props?.activeUser?.user?.imageSrc} className="rounded-circle avatar-lg img-thumbnail" alt="chatvia" />
          }

        </div>

        <h5 className="font-size-16 mb-1 text-truncate">{props.activeUser?.name}</h5>
        <p className="text-muted text-truncate mb-1">
          {(() => {
            switch (props.activeUser?.status) {
              case "online":
                return (
                  <>
                    <i className="ri-record-circle-fill font-size-10 text-success me-1"></i>
                  </>
                )

              case "away":
                return (
                  <>
                    <i className="ri-record-circle-fill font-size-10 text-warning me-1"></i>
                  </>
                )

              case "offline":
                return (
                  <>
                    <i className="ri-record-circle-fill font-size-10 text-secondary me-1"></i>
                  </>
                )

              default:
                return;
            }
          })()}

          Active</p>
      </div>
      {/* End profile user */}

      {/* Start user-profile-desc */}
      <SimpleBar style={{ maxHeight: "67%" }} className="p-4 user-profile-desc">
        <div className="text-muted">
          <p className="mb-4">"{t('If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual.')}"</p>
        </div>

        <div id="profile-user-accordion" className="custom-accordion">
          <Card className="shadow-none border mb-2">
            {/* import collaps */}
            <CustomCollapse
              title="About"
              iconClass="ri-user-2-line"
              isOpen={isOpen1}
              toggleCollapse={toggleCollapse1}
            >

              <div>
                <p className="text-muted mb-1">{t('Name')}</p>

                {isEditing ? (
                  <input
                    type="text"
                    className="form-control font-size-14"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onBlur={handleBlur}
                    autoFocus
                  />
                ) : (
                  <div className="d-flex align-items-center justify-content-between gap-2">
                    <h5 className="font-size-14 m-0">{props.activeUser?.name}</h5>
                    <i
                      className="fa-solid fa-pen-to-square cursor-pointer text-muted"
                      onClick={() => setIsEditing(true)}
                    ></i>
                  </div>
                )}
              </div>

              <div className="mt-4">
                <p className="text-muted mb-1">{t('Email')}</p>
                <h5 className="font-size-14">{props.activeUser?.user?.email}</h5>
              </div>

              <div className="mt-4">
                <p className="text-muted mb-1">{t('Time')}</p>
                <h5 className="font-size-14">11:40 AM</h5>
              </div>

              <div className="mt-4">
                <p className="text-muted mb-1">{t('Location')}</p>
                <h5 className="font-size-14 mb-0">{props.activeUser?.user?.Address.address1}</h5>
              </div>
            </CustomCollapse>
          </Card>
          {/* End About card */}

          <Card className="mb-1 shadow-none border">
            {/* import collaps */}
            <CustomCollapse
              title="Attached Files"
              iconClass="ri-attachment-line"
              isOpen={isOpen2}
              toggleCollapse={toggleCollapse2}
            >
              {/* attached files */}
              <AttachedFiles files={files} />
            </CustomCollapse>
          </Card>

          {
            props.activeUser?.isGroupChat === true &&
            <Card className="mb-1 shadow-none border">
              {/* import collaps */}
              <CustomCollapse
                title="Members"
                iconClass="ri-group-line"
                isOpen={isOpen3}
                toggleCollapse={toggleCollapse3}
              >
                {props.activeUser?.members?.map((member, key) => {
                  return (
                    <Card className="p-2 mb-2" key={key}>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <div className="chat-avatar">

                            {!member?.imageSrc ?
                              <div className="avatar-xs">
                                <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                                  {member?.name?.charAt(0)}
                                </span>
                              </div>
                              :
                              <img src={member?.imageSrc} className="rounded-circle chat-user-img avatar-xs me-3" alt="chatvia" />
                            }
                          </div>
                          <div>
                            <div className="text-left">
                              <h5 className="font-size-14 mb-1">{t(member?.contactName?.first + " " + member?.contactName?.last)}
                                {/* <Badge color="danger" className="badge-soft-danger float-end">{t('Admin')}</Badge> */}
                              </h5>
                              {/* <p className="text-muted font-size-13 mb-0">{member.status}</p> */}
                            </div>
                          </div>
                        </div>

                        <div>
                          <i onClick={() => groupMemberDeleteHandler(member?._id)} className='ri-delete-bin-line font-size-20 text-danger me-1 cursor-pointer'></i>
                        </div>
                      </div>
                    </Card>
                  )
                })}
              </CustomCollapse>
            </Card>
          }
        </div>
      </SimpleBar>
      {/* end user-profile-desc */}
    </div>
  );
}

const mapStateToProps = (state) => {
  const { users, active_user } = state.Chat;
  const { userSidebar } = state.Layout;
  return { users, active_user, userSidebar };
};

export default connect(mapStateToProps, { closeUserSidebar: closeUserSidebar })(UserProfileSidebar);